import React from 'react';

const Cookies: React.FC = () => {
    return (
        <section className="hero-section terms-section text-center text-white">
          <h1 className="hero-headline">Cookie Policy</h1>
          <div className="hero-paragraph text-start mx-auto" style={{ maxWidth: '760px' }}>
            <p className="legal-effective">Version 1.0 — effective 12 September 2026</p>
            <p>
              This policy explains what voycalc.com stores on your device. It supplements our{' '}
              <a href="/?page=privacy" className="text-white">Privacy Policy</a>.
            </p>

            <h2 className="mt-5 h4">1. What this covers</h2>
            <p>
              Norwegian law (ekomloven § 3-15, implementing the ePrivacy Directive) applies to{' '}
              <strong>any storage of, or access to, information on your device</strong> — not only cookies.
              Local storage, session storage and similar mechanisms are covered on the same terms.
            </p>

            <h2 className="mt-5 h4">2. What this website stores: nothing</h2>
            <p>
              voycalc.com itself sets no cookies and stores nothing on your device.{' '}
              <strong>We use no analytics or tracking tools.</strong>
            </p>
            <p>
              Signing in to VoyCalc does not happen on this website — it takes place on your organisation's
              own VoyCalc domain, which is governed by your organisation's agreement with us.
            </p>
            <p>The one exception is the map component on our data pages, described below.</p>

            <h2 className="mt-5 h4">3. The map component on the data pages</h2>
            <p>
              Two pages on this site — the bunker route page and the weather factor page — display a voyage
              route on a map. These pages are not general web pages: they are reached through a{' '}
              <strong>unique link generated for you in your organisation's voyage management system</strong>,
              and the route map is the content that link exists to show. We therefore load the map as a
              necessary part of the service you have requested.
            </p>
            <p>
              The map is provided by <strong>Mapbox</strong>. When a map loads, the Mapbox library stores an{' '}
              <strong>anonymous identifier and usage event data in your browser's local storage</strong>, and
              sends usage telemetry to Mapbox servers.
            </p>
            <table className="legal-table">
              <tbody>
                <tr><th>Provider</th><td>Mapbox, Inc. (United States)</td></tr>
                <tr><th>Where it appears</th><td>The bunker route and weather factor data pages only</td></tr>
                <tr><th>Stored</th><td>Anonymous identifier and event data in local storage</td></tr>
                <tr><th>Sent to</th><td>events.mapbox.com</td></tr>
                <tr><th>Retention</th><td>Identifier refreshed at least every 24 hours</td></tr>
                <tr><th>Transfer</th><td>Outside the EEA, under Standard Contractual Clauses</td></tr>
              </tbody>
            </table>
            <p>
              If you prefer not to allow this, you can block storage for this site in your browser settings —
              the tables and figures on the data pages remain readable, but the map may not display.
            </p>

            <h2 className="mt-5 h4">4. Managing storage</h2>
            <p>
              You can block or delete stored data at any time through your browser settings, per site or
              globally. Because this website stores nothing beyond the map component described above, no
              consent banner is shown and there are no settings to manage on the site itself.
            </p>

            <h2 className="mt-5 h4">5. Changes</h2>
            <p>
              We update this policy when we add or remove a technology that stores information on your
              device. The effective date above shows when it was last changed.
            </p>
            <p>
              Questions:{' '}
              <a href="mailto:privacy@voycalc.com" className="text-white">privacy@voycalc.com</a>
            </p>

            <p className="legal-company mt-5">
              VoyCalc AS — org. no. 938 332 959 — Lindbackveien 9D, 1163 Oslo, Norway
            </p>
          </div>
        </section>
    );
}

export default Cookies
